module.exports = __webpack_public_path__ + "img/add_col_after.e8f3d096.svg";